import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import { useSenatData } from "./senat/hooks/useSenatData";
import { SenatTable } from "./senat/SenatTable";
import { exportToCSV, exportToExcel } from "../utils/exportData";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const SenatTab = () => {
  const { registrations, isLoading, error } = useSenatData();

  const safeDate = (d: string | null | undefined) => {
    if (!d) return "";
    try {
      return format(new Date(d), "dd/MM/yyyy", { locale: fr });
    } catch {
      return d as string;
    }
  };

  const formatForExport = () =>
    registrations.map((r) => ({
      Nom: r.last_name,
      Prénom: r.first_name,
      "Date de naissance": safeDate(r.birth_date),
      "Lieu de naissance": r.birth_place,
      Email: r.email || "",
      Téléphone: r.phone || "",
      Montant: r.amount || 0,
      "Statut paiement": r.payment_status,
      "Date d'inscription": safeDate(r.created_at),
    }));

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Inscriptions Dîner Sénat ({registrations.length})</CardTitle>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => exportToCSV(formatForExport(), "inscriptions-diner-senat")}
            disabled={registrations.length === 0}
          >
            <Download className="h-4 w-4 mr-2" /> CSV
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => exportToExcel(formatForExport(), "inscriptions-diner-senat")}
            disabled={registrations.length === 0}
          >
            <FileSpreadsheet className="h-4 w-4 mr-2" /> Excel
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {isLoading && <p className="text-muted-foreground">Chargement...</p>}
        {error && <p className="text-destructive">Erreur : {error.message}</p>}
        {!isLoading && !error && <SenatTable registrations={registrations} />}
      </CardContent>
    </Card>
  );
};
